export const flowConstants = {
  GET_REQUEST: 'FLOW_GET_REQUEST',
  GET_EVENT_GROUP_TREE_SUCCESS: 'FLOW_GET_EVENT_GROUP_TREE_SUCCESS',
  GET_EVENT_GROUP_TREE_FAILURE: 'FLOW_GET_EVENT_GROUP_TREE_FAILURE',
  TOGGLE_ACTIVE_TAB: 'FLOW_TOGGLE_ACTIVE_TAB',
  SET_SELECTED_NODE: 'FLOW_SET_SELECTED_NODE'
};
